export default {"src":"/_next/static/media/img-btn-banner-prev-arrow.c8356b26.svg","height":14,"width":9,"blurWidth":0,"blurHeight":0};